import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        gap: theme.spacing(3),
    },
    textContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    title: {
        fontWeight: "700 !important",
    },
    subtitle: {
        color: theme.palette.error.light,
    },
    icon: {
        width: "60px !important",
        height: "60px !important",
        color: `${theme.palette.info.main} !important`,
    },
}));
